export default {
    mr: 'M.',
    ms: 'Mme',
    mrs: 'Mme',
    miss: 'Mlle',
    dr: 'Dr.',
    me: 'Me.',
};
